
<div class="table-responsive" *ngIf="users">
<table datatable  [dtOptions]="dtOptions" class="row-border hover table table-striped display compact">
      <thead>
          <tr>
            <th>Date </th>
            <th>First Name </th>
            <th>Last Name</th>
            <th>Switch User</th>
            <th>Username</th>
            <th>Enabled</th>
            <th>Locked</th>
            <th>Expired</th>
            <th>Details</th>

          </tr>
        </thead>
              <tbody>
              <tr *ngFor="let user of users">
                 <td>{{user.dateCreated}}</td>
                  <td>{{user.firstname}}</td>
                  <td>{{user.lastname}}</td>
                  <td>{{22}}</td>
                  <td>{{user.email}}</td>
                  <td>
                      <i *ngIf="user.is_account_enabled!=1" class='fa fa-square-o'></i>
                      <i *ngIf="user.is_account_enabled==1" class='fa fa-check-square-o'></i>
                  </td>
                  <td>
                      <i *ngIf="user.is_account_locked!=1" class='fa fa-square-o'></i>
                      <i *ngIf="user.is_account_locked==1" class='fa fa-check-square-o'></i>
                  </td>
                  <td>
                      <i *ngIf="user.is_account_expired!=1" class='fa fa-square-o'></i>
                      <i *ngIf="user.is_account_expired==1" class='fa fa-check-square-o'></i>
                  </td>
                  <td> <a [routerLink]="['/admin/user/show',user.server_user_id]"> Details</a></td>
                  </tr>
              </tbody>
          </table>
  </div>
  <app-spinner *ngIf="isLoading"> </app-spinner>




